module.exports = __webpack_public_path__ + "static/media/hordeum_vulgare.whole_plant.5614d388.svg";